'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useRef } from 'react';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { SUB_DOMAIN } from '@/constants';
import { usePublishElementHeight } from '@/hooks/usePublishElementHeight';
import { SAFE_AREA_BOTTOM_IOS } from '@/modules/wello-app/_hooks/useMountAppData';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { isAppVersionAtLeast } from '@/utils';
import { DonationBnb } from './_components/DonationBnb';
import { LocalMarketBnb } from './_components/LocalMarketBnb';
import { getFloatingBnbKind } from './constants';
export const FloatingBnbController = () => {
  const $ = _c(16);
  const pathname = usePathname();
  const hideBottomNav = useGlobalStore(_temp);
  const isSafeAreaBottomVersion = useDeviceInfoStore(_temp2);
  let t0;
  if ($[0] !== hideBottomNav || $[1] !== pathname) {
    t0 = hideBottomNav ? null : getFloatingBnbKind(pathname);
    $[0] = hideBottomNav;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const activeBnb = t0;
  const bnbRef = useRef(null);
  const bottomOffset = isSafeAreaBottomVersion ? 10 + SAFE_AREA_BOTTOM_IOS : 10;
  const t1 = !!activeBnb;
  let t2;
  if ($[3] !== bottomOffset || $[4] !== t1) {
    t2 = {
      enabled: t1,
      extraOffset: bottomOffset
    };
    $[3] = bottomOffset;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  usePublishElementHeight(bnbRef, "--floating-bnb-height", t2);
  const t3 = isSafeAreaBottomVersion ? 10 + SAFE_AREA_BOTTOM_IOS : undefined;
  let t4;
  if ($[6] !== t3) {
    t4 = {
      bottom: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activeBnb) {
    t5 = activeBnb === "donation" && <DonationBnb isMounted={true} />;
    $[8] = activeBnb;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== activeBnb) {
    t6 = activeBnb === "localMarket" && <LocalMarketBnb />;
    $[10] = activeBnb;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Portal renderTo={getMainWrapperElement}><div ref={bnbRef} className="fixed inset-x-0 bottom-10 z-20 hidden w-full mobile-tablet:block" style={t4}>{t5}{t6}</div></Portal>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(state) {
  return state.hideBottomNav;
}
function _temp2(state_0) {
  return state_0.subDomain === SUB_DOMAIN.WELLO_APP && state_0.osType === "ios" && !!state_0.appVersion && isAppVersionAtLeast(state_0.appVersion, "3.1.10");
}